// ===== API contracts (match mezzo-service VoxRoi DTOs) =====

export interface VoxRoiConfigResponse {
  encryptedData: string;
  version: number;
  modifiedDate: string;
}

export interface VoxRoiConfigRequest {
  encryptedData: string;
  version: number;
}

export interface VoxProductCatalogItem {
  vendor: string;
  productKey: string;
  productDisplayName: string;
  transactionNames: string[];
  sortOrder: number;
}

export interface VoxRoiProductUsageItem {
  productKey: string;
  vendor: string;
  transactionName: string;
  reportType: string;
  successCount: number;
}

export interface VoxRoiUsageResponse {
  unitCount: number;
  productUsage: VoxRoiProductUsageItem[];
}

// ===== Decrypted config (never sent to Mezzo in plaintext) =====

export const VOX_ROI_CONFIG_VERSION = 1;

export interface VoxRoiCostConfigData {
  version: number;
  avgOrdersPerLoan: number;
  /** cost per product, keyed by catalog productKey */
  productCosts: Record<string, number>;
  /** ordered productKeys selected for the BEFORE column */
  beforeSelection: string[];
}

// ===== Client-side ROI result =====

export interface VoxRoiBeforeProvider {
  productKey: string;
  vendor: string;
  productDisplayName: string;
  costPerOrder: number | undefined;
}

export interface VoxRoiAfterLine {
  productKey: string;
  vendor: string;
  productDisplayName: string;
  successCount: number;
  unitCost: number;
  lineTotal: number;
}

export interface VoxRoiResult {
  unitCount: number;
  before: {
    avgCostPerOrder: number;
    avgOrdersPerLoan: number;
    avgCostPerLoan: number;
    totalSpend: number;
    providerCount: number;
    providers: VoxRoiBeforeProvider[];
  };
  after: {
    totalSpend: number;
    avgCostPerLoan: number;
    lines: VoxRoiAfterLine[];
  };
  savings: {
    total: number;
    pct: number | null;
    perLoan: number;
  };
  warnings: {
    unmappedUsage: VoxRoiProductUsageItem[];
    productsMissingCost: string[];
  };
}
